import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowRight,
  FaLayerGroup,
  FaMapMarkerAlt,
  FaUserTie,
} from "react-icons/fa";

import { resolveMediaUrl, truncateText } from "./homeUtils";

const SectionCard = ({
  title,
  discipline,
  imageSrc,
  logoSrc,
  lienSection,
  responsable,
  adresse,
  category = "Non catégorisée",
}) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (lienSection) navigate(lienSection);
  };

  return (
    <article className="group h-full overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-2xl dark:border-white/10 dark:bg-slate-900">
      <button
        type="button"
        onClick={handleNavigation}
        className="flex h-full w-full flex-col text-left"
      >
        <div className="relative h-52 overflow-hidden">
          <img
            src={resolveMediaUrl(imageSrc, "/img/placeholder-association.jpg")}
            alt={title || "Association"}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-110"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/15 to-transparent" />

          <div className="absolute left-4 top-4 max-w-[calc(100%-2rem)]">
            <span className="inline-flex max-w-full rounded-full bg-white/95 px-3 py-1 text-xs font-bold uppercase tracking-wide text-primary shadow-sm">
              <span className="truncate">{category}</span>
            </span>
          </div>

          {logoSrc && (
            <div className="absolute bottom-4 left-4 flex h-14 w-14 items-center justify-center overflow-hidden rounded-2xl bg-white p-2 shadow-xl">
              <img
                src={resolveMediaUrl(logoSrc)}
                alt={`Logo ${title || "association"}`}
                className="h-full w-full object-contain"
              />
            </div>
          )}
        </div>

        <div className="flex flex-1 flex-col p-5">
          <h3 className="text-xl font-bold leading-snug text-slate-950 dark:text-white">
            {title}
          </h3>

          {discipline && (
            <p className="mt-2 inline-flex items-start gap-2 text-sm font-bold text-primary">
              <FaLayerGroup className="mt-1 shrink-0 text-xs" />
              <span>{discipline}</span>
            </p>
          )}

          {/* {responsable && (
            <p className="mt-3 inline-flex items-start gap-2 text-sm text-slate-500 dark:text-slate-300">
              <FaUserTie className="mt-1 shrink-0 text-primary" />
              <span>{responsable}</span>
            </p>
          )} */}

          {/* {adresse && (
            <p className="mt-3 inline-flex items-start gap-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              <FaMapMarkerAlt className="mt-1 shrink-0 text-primary" />
              <span>{truncateText(adresse, 95)}</span>
            </p>
          )} */}

          <div className="mt-auto pt-2">
            <span className="inline-flex items-center gap-2 text-sm font-bold text-orange-600 transition group-hover:text-orange-700">
              Voir la fiche
              <FaArrowRight className="transition group-hover:translate-x-1" />
            </span>
          </div>
        </div>
      </button>
    </article>
  );
};

export default SectionCard;